import {useQuery} from '@tanstack/react-query';
import {getBrandsFromBrandTreez} from '../../../utils/ProductAPI';
import {updateOfficialBrandOptions} from '../../../redux/actions/ProductMetaDataActions';
import {useDispatch} from 'react-redux';

export const useGetBrandsFromBrandQuery = () => {
    const dispatch = useDispatch();
    return useQuery({
        queryFn: (context) => getBrandsFromBrandTreez(),
        queryKey: ['get-brands-from-brand-treez'],
        onSuccess: (data) => {
            dispatch(updateOfficialBrandOptions(data));
        },
    });
};
